/**
 * User Blocked Me Remapper
 */
import type { UserBlockedMeDto } from '@/data/dtos/userBlockedMe/userBlockedMeDto';
import type { JsonObject } from '@/data/types/json';
import type { UserBlockedMeStorage } from '@/domain/entities/secureStorage/secureStorageEntities';

export class UserBlockedMeRemapper {
  static toStorage(dto: UserBlockedMeDto): UserBlockedMeStorage {
    return {
      firebaseId: dto.firebaseId,
    };
  }

  static fromFirebaseId(firebaseId: string): UserBlockedMeStorage {
    return {
      firebaseId,
    };
  }

  static fromJson(data: JsonObject): UserBlockedMeDto {
    return {
      firebaseId: (data['firebaseId'] as string | undefined) ?? '',
    };
  }

  static fromJsonList(dataList: JsonObject[]): UserBlockedMeDto[] {
    return dataList.map(UserBlockedMeRemapper.fromJson);
  }
}
